var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-gallery" },
    [
      _c("div", { staticClass: "c-gallery-imagearea" }, [
        _vm.currentImage.iframe
          ? _c("div", { staticClass: "iframe-container" }, [
              _c("iframe", {
                staticClass: "c-gallery-iframe",
                attrs: {
                  src: _vm.currentImage.iframeSrc,
                  frameborder: "0",
                  allowfullscreen: "allowfullscreen",
                  allowvr: "true"
                }
              })
            ])
          : _c(
              "figure",
              {
                class: [
                  "c-gallery__main-image",
                  { "c-gallery__main-image-ie11-fix": _vm.images.length === 1 }
                ],
                attrs: {
                  id: "gallery" + _vm.randomNumber,
                  "aria-live": _vm.isLive !== "" ? _vm.isLive : false,
                  "aria-atomic": _vm.isAtomic !== "" ? _vm.isAtomic : false,
                  "aria-labelledby": _vm.currentId
                }
              },
              [
                _c("img", {
                  attrs: {
                    src: _vm.currentImage.imageUrl,
                    alt: _vm.currentImage.text,
                    title: _vm.currentImage.text
                  }
                }),
                _vm._v(" "),
                _vm.currentImage.labelText
                  ? _c(
                      "div",
                      {
                        staticClass: "c-gallery-imagetext-labelarea",
                        style:
                          "background-color: " + _vm.currentImage.labelColor
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass: "c-gallery-imagetext-labelarea--text"
                          },
                          [_vm._v(_vm._s(_vm.currentImage.labelText))]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentImage.imageText
                  ? _c("div", { staticClass: "c-gallery-imagetext" }, [
                      _c("p", [_vm._v(_vm._s(_vm.currentImage.imageText))])
                    ])
                  : _vm._e()
              ]
            )
      ]),
      _vm._v(" "),
      _vm.images.length >= _vm.minNumToShow
        ? _c("v-gallery-image-scroller-small", {
            attrs: {
              images: _vm.images,
              "thumbnail-width": _vm.thumbnailWidth,
              "aria-controls": "gallery" + _vm.randomNumber,
              "controls-live-region": true,
              "min-num-to-show": "2"
            },
            on: { selectImage: _vm.selectImage }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }